import Vue from 'vue'
import Toasted from 'vue-toasted';
import escapeHtml from 'lodash/escape';

Vue.use(Toasted);

let failedOptions = {
    className: 'mToasted',
    position: 'bottom-right',
    type : 'error',
    icon : 'sad-tear',
    duration: 4000,
    iconPack:'fontawesome',
};

Vue.toasted.register('failedRequest',
    (payload) => {
        if(! payload.message) {
            return "Oops.. Something Went Wrong.."
        }
        return "Oops.. " + escapeHtml(payload.message);
    },
    failedOptions
);

let failedFormOptions = {
    className: 'mToasted',
    position: 'bottom-right',
    type : 'error',
    icon : 'sad-tear',
    duration: 4000,
    iconPack:'fontawesome',
};

Vue.toasted.register('failedFormRequest',
    (payload) => {
        if(!payload.message) {
            return "Niet alle velden zijn juist ingevuld."
        }
        return escapeHtml(payload.message);
    },
    failedFormOptions
);

let successOptions = {
    className: 'mToasted',
    position: 'bottom-right',
    type : 'success',
    duration: 3000,
    icon : 'smile',
    iconPack:'fontawesome',
};

Vue.toasted.register('successRequest',
    (payload) => {
        if(!payload.message) {
            return "Succesvol bijgewerkt"
        }
        return escapeHtml(payload.message);
    },
    successOptions
);

let infoOptions = {
    className: 'mToasted',
    position: 'bottom-right',
    type : 'info',
    duration: 3000,
    icon : {name:'lightbulb-on'},
    iconPack:'fontawesome',
    singleton:true,
};

Vue.toasted.register('info',
    (payload) => {
        if(!payload.message) {
            return " "
        }
        return escapeHtml(payload.message);
    },
    infoOptions
);